// ** React Imports
import React, { Fragment } from 'react';

// ** Third Party Components
import ReactSelect from 'react-select';

// ** Reactstrap Imports
import { FormFeedback, Label } from 'reactstrap';
import { customFilterOption, customGetOptionLabel } from 'utils/commonFunc';

export const requiredIcon = (
  <span style={{ color: 'red' }}>
    <sup>*</sup>
  </span>
);

const CustomSelect = props => {
  const {
    noLabel = false,
    name = '',
    label = 'Select',
    defaultValue = null,
    value = null,
    options = [],
    isClearable = false,
    onSelect,
    onChange,
    placeholder = 'Select...',
    isRequired = false,
    isMulti = false,
    error = '',
    style = null,
    disabled,
    onInputChange,
    applyLabelStyle = false,
    isValueIsItem = false,
    loading = false,
    // When true, renders the dropdown menu into document.body instead of inline.
    // Needed for selects nested inside a Modal/small container where the menu would
    // otherwise be clipped by, or render underneath, the modal's own chrome (e.g. its
    // footer buttons), making options unclickable.
    usePortal = false,
  } = props;
  return (
    <Fragment>
      {!noLabel && (
        <Label className="form-label">
          {label} {isRequired && requiredIcon}
        </Label>
      )}
      <ReactSelect
        className="react-select"
        classNamePrefix="select"
        defaultValue={defaultValue}
        value={options?.find(el => el.value === value) || null}
        options={options}
        isClearable={isClearable}
        onChange={item => {
          if (!item || item?.value !== value) {
            onSelect && onSelect(name, isValueIsItem ? item : !isValueIsItem ? item?.value : null);
            onChange && onChange(name, isValueIsItem ? item : !isValueIsItem ? item?.value : null);
          }
        }}
        placeholder={placeholder}
        isMulti={isMulti}
        menuPortalTarget={usePortal ? document.body : undefined}
        menuPosition={usePortal ? 'fixed' : undefined}
        styles={{
          control: provided => ({
            ...provided,
            ...(error && { borderColor: 'red' }),
            ...(style && { ...style }),
          }),
          ...(usePortal && { menuPortal: provided => ({ ...provided, zIndex: 9999 }) }),
        }}
        isDisabled={disabled}
        onInputChange={text => {
          onInputChange?.(text);
        }}
        getOptionLabel={applyLabelStyle ? customGetOptionLabel : undefined}
        filterOption={applyLabelStyle ? customFilterOption : undefined}
        isLoading={loading}
      />
      {error && typeof error === 'string' && <FormFeedback style={{ display: 'inline-block' }}>{error}</FormFeedback>}
    </Fragment>
  );
};

export default CustomSelect;
